import { useCallback } from "react";

import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useAnalytics from "hooks/useAnalytics";
import useCanDeleteIntegrations from "shared/Integrations/access/useCanDeleteIntegrations";
import { BillingTierFeature, ExternalIntegration } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import { showDeleteConfirmation } from "../../../../ServiceNow/components/DeleteConfirmation";
import { showIntegrationDetailsDrawer } from "../../IntegrationDetailsDrawer";

const BackstageIntegrationTableRowActionsCell = ({
  item: integration,
  ...cellProps
}: TableSimpleCellProps<ExternalIntegration>) => {
  const canDeleteIntegrations = useCanDeleteIntegrations(BillingTierFeature.BackstageIntegration);
  const trackAnalytics = useAnalytics();

  const openDetailsDrawer = useCallback(() => {
    showIntegrationDetailsDrawer({
      integration,
      id: integration.id,
    });
  }, [integration]);

  const handleDelete = () => {
    showDeleteConfirmation({
      id: integration.id,
      attachedEntities: integration.attachedBlueprints.length,
      name: integration.name,
      refetchQueriesOnDelete: ["GetAccountExternalIntegrations"],
    });
  };

  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="Integration actions" dotsSize="small">
        <CopyFieldDropdownMenuItem
          title="Copy ID"
          value={integration.apiKey.id}
          onCopy={() => trackAnalytics("Copy ID")}
        />
        <DropdownMenuItem onAction={openDetailsDrawer}>See details</DropdownMenuItem>
        <DropdownMenuItem
          tooltip={"You don't have permission to delete this integration"}
          isDisabled={!canDeleteIntegrations}
          isTooltipActive={!canDeleteIntegrations}
          onAction={handleDelete}
          danger
        >
          Delete
        </DropdownMenuItem>
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default BackstageIntegrationTableRowActionsCell;
